export default __webpack_public_path__ + "static/media/Immagine_5.5dba6e42.jpg";